var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayments = function SvgPayments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.118 8.559H2.25M3.397 15.441H2.25M3.97 12H1.103M5.273 4.7a10.324 10.324 0 1 1 0 14.6M16.44 11.25H7.86",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.3 7.985h-6.249c-.76 0-1.43.499-1.648 1.227l-1.204 4.014a1.72 1.72 0 0 0 1.648 2.215h6.249c.76 0 1.43-.498 1.648-1.226l1.204-4.015A1.72 1.72 0 0 0 16.3 7.985Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPayments;